<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 员工管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="员工昵称:" label-width="75px">
                        <el-input v-model="query.nickname" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                >批量删除</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable= true"
                >添加</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
               
                <el-table-column prop="nickname" label="员工昵称"  align="center"></el-table-column>
                <el-table-column prop="sex" label="性别"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sex == 1">男</span>
                        <span v-if="scope.row.sex == 2">女</span>
                    </template>
                </el-table-column>
                 <el-table-column prop="headimgurl" label="头像"  align="center">
                            <template slot-scope="scope">
                            <el-image
                                class="table-td-thumb"
                                :src="scope.row.headimgurl"
                                :preview-src-list="[scope.row.headimgurl]"
                            ></el-image>
                        </template>
                </el-table-column>
                <el-table-column prop="employees_commission" label="员工抽成(%)" width="120" align="center">
                     <template slot-scope="scope">
                           <span> {{scope.row.employees_commission}}%</span>
                        </template>
                   
                </el-table-column>
                <el-table-column prop="k_money" label="可提现金额(元)"  width="200" align="center"></el-table-column>
                <el-table-column prop="y_money" label="已提现金额(元)"  width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        @click="mingxiInfo(scope.$index, scope.row)"
                    >{{scope.row.y_money}}(点击查看明细)
                    </el-button>
                    </template>
            
                </el-table-column>
                <el-table-column prop="count_money" label="总提成"  align="center"></el-table-column>
                       
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                         <el-button
                            type="text"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑
                        </el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                        
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
         <!-- 添加弹出框 -->
        <el-dialog title="添加员工" :visible.sync="addVisiable" width="500px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="120px" >
                <el-form-item prop="id" label="用户昵称">  
                  <el-select
                    v-model="addForm.id"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    style="width:360px">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    <span style="float: left">{{item.label}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">Openid:{{item.openid}}</span>
                    </el-option>
                  </el-select>
               </el-form-item>
               <el-form-item prop="employees_commission" label="员工抽成(%)">
                    <el-input v-model="addForm.employees_commission"></el-input>
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 编辑弹出框 -->
        <el-dialog title="修改员工抽成" :visible.sync="editVisible" width="500px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="120px" >
               <el-form-item prop="employees_commission" label="员工抽成(%)">
                    <el-input v-model="editForm.employees_commission"></el-input>
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提现明细" :visible.sync="lookVisiable" width="1500px">
            <div class="handle-box" style="width:1500px">
                <el-form :model="queryMingxi" ref="queryMingxi" label-width="80px" inline="">
                    <el-form-item label="收款账号:" label-width="75px" prop="account">
                        <el-input v-model="queryMingxi.account" placeholder="请输入" class="handle-input mr10" @input="inputSearch1(mingxiOpneid)"></el-input>
                    </el-form-item>
                    <el-form-item label="收款人:" label-width="75px" prop="name">
                        <el-input v-model="queryMingxi.name" placeholder="请输入" class="handle-input mr10" @input="inputSearch1(mingxiOpneid)"></el-input>
                    </el-form-item>
                    <el-form-item label="提现方式:" label-width="75px" prop="mode">
                        <el-select v-model="queryMingxi.mode" placeholder="请输入" class="handle-input mr10" @change="inputSearch1(mingxiOpneid)">
                             <el-option v-for="item in modeList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请时间" >
                        <el-date-picker class="data" type="date" placeholder="起始日期" v-model="queryMingxi.start_time" style="width: 150px;padding-right:5px"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" @change="inputSearch1(mingxiOpneid)"></el-date-picker>
                        <span>-</span>
                        <el-date-picker  format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="data" type="date" placeholder="结束日期" v-model="queryMingxi.end_time" style="width: 150px;padding-right:10px;padding-left:5px" @change="inputSearch1(mingxiOpneid)">
                        </el-date-picker>
                   </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getmingxi(mingxiOpneid)">搜索</el-button>
                    <el-button type="primary"  @click="resetsearchTixian()">重置</el-button>
                </el-form>
            </div>
            <el-table
                :data="mingxi"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="id" label="ID" width="55" align="center"  fixed="left"></el-table-column>
                <el-table-column prop="name" label="用户昵称"  align="center"></el-table-column>
                <el-table-column prop="mode" label="提现方式" width="150" align="center"></el-table-column>
                <el-table-column prop="account" label="收款账号"  width="200" align="center"></el-table-column>
                <el-table-column prop="opening" label="开户银行" width="150" align="center"></el-table-column>
                <el-table-column prop="amount" label="提现金额"  align="center"></el-table-column>
                <el-table-column prop="can_withdraw" label="可到账金额"  align="center"></el-table-column>
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                       <span v-if="scope.row.status==1" style="color:rgb(22,162,251)">待审核</span>
                       <span v-else-if="scope.row.status==2" style="color:rgb(236, 160,70)">待打款</span>
                       <span v-else-if="scope.row.status==3" style="color:rgb(22,162,51)">提现成功</span>
                       <span v-else style="color:rgb(242, 94, 67)">提现失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="start_time" label="申请时间" width="180" align="center"></el-table-column>
                <el-table-column prop="end_time" label="到账时间"  width="180" align="center"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="queryMingxi.pageIndex"
                    :page-size="queryMingxi.pageSize"
                    :total="pageTotalMingxi"
                    @current-change="handlePageChangeMingxi"
                ></el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
         var employ_commission = (rule, value, callback) => {
            const reg = /^\d+.?\d{0,2}$/
            if(!value){
                 callback(new Error('请输入员工抽成'))
            }
            else if (!Number(value)) {
                callback(new Error('请输入数字值'))
            } else if(value<0||value>100){
                callback(new Error('请输入大于0小于100的抽成'))
            }else {
                if (reg.test(value)) {
                callback()
                } 
                else {
                callback(new Error('小数点后最多只能输入两位'))
                }
            }
        }
        return {
            modeList:[{
                label:"微信零钱"
            },{
                label:"微信线下打款"
            },{
                label:"支付宝线下打款"
            },{
                label:"银联线下打款"
            }],
            modeVisiable:false,
            queryMingxi: {
                account:'',
                mode:'',
                name:'',
                start_time:'',
                end_time:'',
                status:'',
                pageIndex: 1,
                pageSize: 8,
                cpyid:""
            },
            options: [],
            value: [],
            list: [],
            loading: false,
            userList:[],
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                nickname: '',
                pageIndex: 1,
                pageSize: 8
            },
            pageTotal: 0,
            //添加数据
            addVisiable:false,
            addForm:{
               id:'',
               employees_commission:'',
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                id: [
                    { required: true, message: '请选择用户', trigger: 'blur' },
                ],
                employees_commission: [
                    { required: true, message:"请输入", trigger: 'blur' },
                 
                ]
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1,
            mingxi:[],
            lookVisiable:false,
            mingxiOpneid:"",
            pageTotalMingxi:0
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
    },
    mounted() {
      this.getList()
    },
    methods: {
        mingxiInfo(index,row){
            this.mingxiOpneid = row.openid
            this.getmingxi(this.mingxiOpneid)
        },
        resetsearchTixian(){
            this.queryMingxi.account= '',
            this.queryMingxi.name='',
            this.queryMingxi.start_time= '',
            this.queryMingxi.end_time= '',
            this.queryMingxi.mode= '',
            this.getmingxi(this.mingxiOpneid)
        },
        getmingxi(openid){
            this.lookVisiable = true
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',this.queryMingxi.pageIndex)
            formdata.append('limit',this.queryMingxi.pageSize)
            formdata.append('mode',this.queryMingxi.mode)
            formdata.append('account',this.queryMingxi.account)
            formdata.append('name',this.queryMingxi.name)
            formdata.append('start_time',this.queryMingxi.start_time)
            formdata.append('end_time',this.queryMingxi.end_time)
            formdata.append('status',3)
            formdata.append('openid',openid)
            post("admin/Order/selempcom",formdata).then(res=>{
                this.mingxi = res.data.data.list
                this.pageTotalMingxi = res.data.data.num
            })
        },
        inputSearch1(openid){
            this.lookVisiable = true
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',1)
            formdata.append('limit',this.queryMingxi.pageSize)
            formdata.append('mode',this.queryMingxi.mode)
            formdata.append('account',this.queryMingxi.account)
            formdata.append('name',this.queryMingxi.name)
            formdata.append('start_time',this.queryMingxi.start_time)
            formdata.append('end_time',this.queryMingxi.end_time)
            formdata.append('status',3)
            formdata.append('openid',openid)
            post('admin/Order/selempcom',formdata).then(res => {
                if(res.data.data){
                    this.mingxi = res.data.data.list;
                    this.pageTotalMingxi = res.data.data.num
                }
            });
        },
        remoteMethod(query) {
            if (query !== '') {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                this.options = this.list.filter(item => {
                return item.label.toLowerCase()
                    .indexOf(query.toLowerCase()) > -1;
                });
            }, 200);
            } else {
            this.options = [];
            }
        },
        getList(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',1)
            formdata.append('limit',1000000000000)
            post('admin/user/userlist',formdata).then(res => {
                if(res.code=200){
                    this.userList = res.data.data.list;
                    this.list = this.userList.map(item => { //组装，只需要id和name
                        return {value: item.id, label: item.nickname,openid: item.openid};
                    });
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        addData(){
            let formdata = new FormData()
            formdata.append('id',this.addForm.id)
            formdata.append('company_id',this.companyid)
            formdata.append('employees_commission',this.addForm.employees_commission )
            let url  = 'admin/employees/addemploy'
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    post(url,formdata).then(res=>{
                        if(res.data.msg =="添加成功"){
                            this.$message.success("添加成功")
                            this.getData()
                            this.$refs['addForm'].resetFields();
                            this.addVisiable = false 
                        }
                        else{
                            this.$messaga.error("添加失败")
                        }          
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        updateStatus(index,row){
            let formdata = new FormData()
            let url = 'admin/admin_user/disables'
            formdata.append('id',row.id)
            if(row.disable==1){
                url = 'admin/admin_user/starts'
            }
            post(url,formdata).then(res=>{
                if(res.data.msg =="禁用失败"){
                    this.$message.error("禁用失败")
                } 
                else if(res.data.msg =="禁用成功"){
                    this.$message.success("禁用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用成功"){
                    this.$message.success("启用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用失败"){
                    this.$message.error("启用失败")
                    this.getData()
                }      
            })
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch(){
            this.query.nickname= '',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('nickname',this.query.nickname)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/employees/employinfo',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('nickname',this.query.nickname)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/employees/employinfo',formdata).then(res => {
                if(res.data.data){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/employees/dele',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/employees/alldele',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editForm.employees_commission = parseInt(this.editForm.employees_commission )
            this.editVisible = true;
        
        },
        // 保存编辑
        saveEdit() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('employees_commission',this.editForm.employees_commission)
                    post('admin/employees/upd',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        handlePageChangeMingxi(val){
            this.$set(this.queryMingxi, 'pageIndex', val);
            this.getmingxi();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
